import { fitPolicy } from "./spacePolicyValues.js";

export const DEFINITION_FIELDS = Object.freeze({
  fit: ["under_used_pct", "space_fit_tight_pct", "density_floor_sf"],
  outlook: ["outlook_near_limit_pct"],
});
export const COMPANY_THRESHOLDS = ["under_used_pct", "space_fit_tight_pct", "outlook_near_limit_pct"];
export function definitionPolicy(row = {}) {
  row ??= {};
  return {
    underUsedPct: Number(row.under_used_pct ?? 80),
    hcBufferPct: Number(row.target_buffer_pct ?? 10),
    tightPct: Number(row.space_fit_tight_pct ?? 100 - Number(row.target_buffer_pct ?? 10)),
    nearLimitPct: Number(row.outlook_near_limit_pct ?? 100 - Number(row.target_buffer_pct ?? 10)),
    sfFloor: Number(row.density_floor_sf ?? 150),
  };
}
export function validateThresholds(merged) {
  const p = definitionPolicy(merged);
  if (fitPolicy(p) && p.tightPct < 100 && p.nearLimitPct < 100) return {};
  return { _form: "Use finite values with 0 ≤ Under-Used < Tight < 100, 0 < Near limit < 100, and a positive density floor." };
}
